import React from 'react';
import { Gradient } from '../Gradient';

const Rocket = ({ type, className = '', color = '#737373' }) => {
  return (

<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
<path d="M6.35298 4.26949L3.52131 4.57741C2.90605 4.64431 2.37852 5.04658 2.15119 5.6222L1.28033 7.82725C0.994293 8.55151 1.76947 9.23754 2.45358 8.86558L4.54503 7.7914M11.5467 9.68672L11.2388 12.5184C11.1719 13.1336 10.7696 13.6612 10.194 13.8885L7.98893 14.7594C7.26467 15.0454 6.57864 14.2702 6.9506 13.5861L8.10959 11.4266M14.6052 1.35253C15.4386 2.18594 14.8632 6.02967 12.1376 8.75529C11.0553 9.83759 9.88014 10.6643 8.77123 11.1825C6.84695 12.0816 7.46104 10.6154 6.40166 9.55603C5.34224 8.49662 3.87604 9.11082 4.77522 7.18646C5.29336 6.07755 6.1201 4.90242 7.2024 3.82011C9.92802 1.09449 13.7718 0.519118 14.6052 1.35253ZM4.20877 13.9281C3.65497 14.4819 1 15.1314 1 15.1314C1 15.1314 1.64949 12.4765 2.20329 11.9227C2.75709 11.3689 3.65497 11.3689 4.20877 11.9227C4.76257 12.4765 4.76257 13.3743 4.20877 13.9281ZM12.105 4.6862C12.105 5.14648 11.7319 5.51962 11.2716 5.51962C10.8113 5.51962 10.4382 5.14648 10.4382 4.6862C10.4382 4.22591 10.8113 3.85278 11.2716 3.85278C11.7319 3.85278 12.105 4.22591 12.105 4.6862Z" 
stroke={type === 'plain' ? color : 'url(#globalGradient)'} 
      strokeWidth="1" 
      strokeLinecap="round"/>
      <Gradient className={className} />
</svg>


  );
};

export default Rocket;